import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import { AnimatePresence } from "framer-motion";

import * as P from "~/pages";

const Routes = () => {
  return (
    <Route
      render={({ location }) => (
        <AnimatePresence exitBeforeEnter initial={false}>
          <Switch location={location} key={location.pathname}>
            <Route exact path="/" component={P.Home} />
            <Route exact path="/regulamento" component={P.Regulation} />
            <Route exact path="/informacoes-legais" component={P.LegalInformation} />
            <Route exact path="/vencedores" component={P.PromotionWinners} />
            <Route exact path="/login" component={P.Login} />
            <Route exact path="/faq" component={P.Faq} />
            <Route exact path="/login/:code" component={P.Login} />
            <Route exact path="/esqueci-minha-senha" component={P.ForgotPass} />
            <Route exact path="/cadastre-se" component={P.SignUp} />
            <Redirect exact from="/cadastre-se/passo-1" to="/cadastre-se" />
            <Route exact path="/cadastre-se/passo-1/verificacao-email" component={P.SignUpStep1EmailVerification} />
            <Route exact path="/cadastre-se/passo-1/dados-pessoais" component={P.SignUpStep12} />
            <Route exact path="/cadastre-se/passo-1/bebe" component={P.SignUpStep13} />
            <Route exact path="/cadastre-se/passo-1/dados-contato" component={P.SignUpStep14} />
            <Route exact path="/cadastro-complementar" component={P.SignupComplement} />
            <Route exact path="/verifique-seu-email" component={P.VerifyEmail} />
            <Route exact path="/verifique-seu-novo-email/:code" component={P.VerifyNewEmail} />
            <Route exact path="/cadastro-validado/:code" component={P.VerifiedEmail} />
            <PrivateRoute exact path="/cadastro-promo" component={P.PromoReg} />
            <PrivateRoute exact path="/cadastro-promo/sucesso" component={P.PromoRegSuccess} />
            {/* <PrivateRoute exact path="/atualizar-senha" component={P.UpdatePassword} /> */}
            <PrivateRoute exact path="/minha-conta" component={P.MyAccount} />
            <Route component={P.Error404} />
          </Switch>
        </AnimatePresence>
      )}
    />
  );
};

export default Routes;
